import { AbilityBuilder, Ability } from '@casl/ability';
import { User } from '@/constants/types';
import { USER_ROLES } from '@/constants/app';

export type Actions = 'create' | 'read' | 'update' | 'delete' | 'manage';
export type Subjects = 'User' | 'Student' | 'Staff' | 'Parent' | 'Dashboard' | 'Profile' | 'all';

export type AppAbility = Ability<[Actions, Subjects]>;

export const defineAbilitiesFor = (user: User | null): AppAbility => {
  const { can, cannot, build } = new AbilityBuilder<AppAbility>(Ability);

  if (!user) {
    cannot('manage', 'all');
    return build();
  }

  switch (user.role) {
    case USER_ROLES.ADMINISTRATOR:
      can('manage', 'all');
      break;
    case USER_ROLES.SUPER_ADMIN:
      can('manage', 'all');
      break;
    case USER_ROLES.STAFF:
      can('read', 'Dashboard');
      can('manage', 'Student');
      can('read', 'Parent');
      can('read', 'User');
      can('update', 'Profile');
      cannot('delete', 'User');
      cannot('create', 'Staff');
      cannot('update', 'Staff');
      cannot('delete', 'Staff');
      break;

    case USER_ROLES.STUDENT:
      can('read', 'Profile');
      can('update', 'Profile');
      cannot('read', 'Dashboard');
      cannot('manage', 'Student');
      cannot('manage', 'Staff');
      cannot('manage', 'Parent');
      cannot('manage', 'User');
      break;

    case USER_ROLES.PARENTS:
      can('read', 'Profile');
      can('update', 'Profile');
      can('read', 'Student');
      cannot('read', 'Dashboard');
      cannot('manage', 'Staff');
      cannot('manage', 'User');
      cannot('create', 'Student');
      cannot('update', 'Student');
      cannot('delete', 'Student');
      break;

    default:
      cannot('manage', 'all');
      break;
  }

  return build();
};

export const checkPermission = (
  user: User | null,
  action: Actions,
  subject: Subjects
): boolean => {
  const ability = defineAbilitiesFor(user);
  return ability.can(action, subject);
};